import storyForm from './form--story.js';
import placeForm from './form--place.js';
import userForm from './form--user.js';
import loginForm from './form--login.js';
import passwordForm from './form--password.js';

function init() {

	storyForm.init();
	placeForm.init();
	userForm.init();
	loginForm.init();
	passwordForm.init();

	$('.form').on('click', '.place-slip a', (event) => {
		event.preventDefault();
	});

	$('a.button').on('click', '.disabled', (event) => {
		event.preventDefault();
	});

}

export default {
	init
};
